<template>
    <v-container class="grey lighten-5" fluid>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-row>
            <v-col md="8" offset-md="2">
                <v-card class="pa-5" shaped>
                    <div class="d-flex justify-center">
                        <router-link :to="{ name: 'Login'}">
                            <v-img src="../assets/tp-logo.png" max-width="80"></v-img>
                        </router-link>
                    </div>
                    <v-form ref="form" lazy-validation @submit="onSubmit">
                        <v-row>
                            <v-col md="6" class="pr-3">
                                <v-text-field
                                            v-model="onBoard.merchant"
                                            :rules="[rules.required, validMerchant]"
                                            label="Merchant Name"
                                            maxlength="32"
                                            required
                                ></v-text-field>
                                <v-text-field
                                            v-model="onBoard.url"
                                            :rules="[rules.required, validUrl]"
                                            label="URL"
                                            required
                                ></v-text-field>
                                <v-select
                                        v-model="onBoard.schemes"
                                        :items="schemes"
                                        :rules="[rules.required]"
                                        multiple
                                        label="Payment Schemes"
                                ></v-select>
                                <v-select
                                        v-model="onBoard.currencies"
                                        :items="currencies"
                                        :rules="[rules.required]"
                                        multiple
                                        label="Currencies"
                                ></v-select>
                            </v-col>

                            <v-col md="6" class="pl-3">
                                <v-text-field
                                    v-model="email"
                                    :rules="[rules.required, validEmail]"
                                    :error-messages="dupeEmail"
                                    label="Email Address"
                                    required
                                ></v-text-field>
                                <v-text-field
                                    v-model="onBoard.firstName"
                                    :rules="[rules.required]"
                                    label="First Name"
                                    required
                                ></v-text-field>
                                <v-text-field
                                    v-model="onBoard.surname"
                                    :rules="[rules.required]"
                                    label="Surname"
                                    required
                                ></v-text-field>
                                <!-- <v-select
                                        v-model="onBoard.recType"
                                        :items="recType"
                                        multiple
                                        label="Recurring Type"
                                ></v-select>
                                <v-select
                                        v-model="onBoard.threeD"
                                        :items="threeD"
                                        multiple
                                        label="3D Type"
                                ></v-select> -->
                            </v-col>
                        </v-row>
                        <v-divider class="pb-4" horizontal></v-divider>
                        <v-card-actions class="pr-0">
                            <v-spacer></v-spacer>
                            <v-btn @click="onReset" color="error">Reset</v-btn>
                            <v-btn type="submit" color="primary">Ok</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="errors.length">
            <v-col md="8" offset-md="2">
                <v-alert type="error" text border="left" dismissible>
                    <div v-for="(error, id) in errors" :key="id">{{ error }}</div>
                </v-alert>
            </v-col>
        </v-row>

        <v-row v-if="success">
            <v-col md="8" offset-md="2">
                <v-alert type="success" text border="left" dismissible>
                    Test merchant account successfully created.
                </v-alert>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    watch: {
        email(v) {
            axios({
            method: 'post',
            url: 'username-check',
            data: { username: v },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.dupeEmail = response.data == 1 ? ['Username already exists'] : [];
                this.onBoard.email = v;
            })
            .catch(e => {
                this.errors.push(e)
            })
        }
    },
    data() {
        return {
            onBoard: {
                merchant: '',
                url: null,
                schemes: null,
                currencies: null,
                email: null,
                firstName: null,
                surname: null,
                merchantIdVi: '147777776',
                merchantIdMc: '157777776',
                terminalId: '71F00013',
                recType: ['nonrec', 'rec'],
                threeD: ['non3d', '3d'],
                transactionCategory: 'ECOMMERCE',
                merchantCategory: 'RETAIL'
            },
            email: null,
            dupeEmail: [],
            errors: [],
            success: false,
            merchants: [],
            contacts: [],
            rules: {
                required: v => !!v || 'Required.',
            },
            schemes: [{ value: 'MASTER', text: 'Mastercard'},
                      { value: 'VISA', text: 'Visa'}],
            // recType: [{ value: 'nonrec', text: 'Non-Recurring'},
            //          { value: 'rec', text: 'Recurring'}],
            // threeD: [{ value: 'nond3d', text: 'Non 3D Channel'},
            //          { value: '3d', text: '3D Channel'}],
            currencies: [{ value: 'AUD', text: 'AUD' },
                         { value: 'CAD', text: 'CAD' },
                         { value: 'COP', text: 'COP' },
                         { value: 'CHF', text: 'CHF' },
                         { value: 'CZK', text: 'CZK' },
                         { value: 'DKK', text: 'DKK' },
                         { value: 'GBP', text: 'GBP' },
                         { value: 'EUR', text: 'EUR' },
                         { value: 'INR', text: 'INR' },
                         { value: 'HUF', text: 'HUF' },
                         { value: 'JPY', text: 'JPY' },
                         { value: 'KRW', text: 'KRW' },
                         { value: 'MYR', text: 'MYR' },
                         { value: 'MXN', text: 'MXN' },
                         { value: 'NOK', text: 'NOK' },
                         { value: 'NZD', text: 'NZD' },
                         { value: 'PLN', text: 'PLN' },
                         { value: 'NOK', text: 'NOK' },
                         { value: 'NZD', text: 'NZD' },
                         { value: 'RON', text: 'RON' },
                         { value: 'RUB', text: 'RUB' },
                         { value: 'SEK', text: 'SEK' },
                         { value: 'SGD', text: 'SGD' },
                         { value: 'THB', text: 'THB' },
                         { value: 'TRY', text: 'TRY' },
                         { value: 'TWD', text: 'TWD' },
                         { value: 'USD', text: 'USD' },
                         { value: 'ZAR', text: 'ZAR' }],
            loading: false,
            username: false,
        }
    },
    beforeMount() {
        this.listMerchants();
    },
    methods: {
        onSubmit(e) {
            e.preventDefault();
            this.loading = true;
            this.errors = [];

            if(this.$refs.form.validate()) {
                axios({
                method: 'post',
                url: 'onboard-test-account',
                data: { onBoard: this.onBoard, state: 'Test' },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    console.log(response);
                    this.listMerchants();

                    if(response.data != 1 && 'error' in response.data) {
                        this.errors.push(response.data.error.message);
                    }
                    this.loading = false;
                    this.success = response.data;
                    this.onBoard.merchant = '';
                    this.onBoard.email = '';
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        onReset(e) {
            this.$refs.form.reset();
        },
        listMerchants() {
            axios({
            method: 'post',
            url: 'list-merchants',
            data: { divisionId: '8a829417567d952801568db2042d0c35', state: 'Test' },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.merchants = response.data.merchants;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        validMerchant(e) {
            return !this.merchants.some(m => m.name.toLowerCase() === e.toLowerCase()) || 'Merchant already exists.';
        },
        validEmail(e)  {
            let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(e) || 'Invalid email address.'
        },
        validUrl(e) {
            // let pattern = /^((https?|ftp|smtp):\/\/)?(www.)?[-a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$/;
            let pattern = new RegExp(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi);
            return pattern.test(e) || 'Invalid URL.';
        }
    }
}
</script>